import { CSSObject } from 'libs/ui/styled';
import { Theme } from 'libs/ui/theme';

import { ChipVariant } from '../types';

export const getChipSizes = (theme: Theme, variant: ChipVariant): CSSObject => {
  switch (variant) {
    case 'medium':
      return {
        padding: '4px 12px',
        [theme.breakpoints.down('mobile')]: { padding: '3px 12px' },
      };
    case 'small':
      return { padding: '0px 12px' };
    default:
      return { padding: '12px 20px' };
  }
};
